import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ProjectsApi} from "@core/services/backend/common/api/projects.api";
import {ProjectsV2Api} from "@core/services/backend/common/api/projects-v2.api";
import {HttpService} from "@core/services/backend/common/api/http.service";
import {ProjectsData} from "@core/services/backend/common/interface/projects";
import {ProjectsService} from "@core/services/backend/common/service/projects.service";
import {ProjectsV2Service} from "@core/services/backend/common/service/projects-v2.service";
import {UsersApi} from "@core/services/backend/common/api/users.api";
import {UsersData} from './common/interface/users';
import {UsersService} from "@core/services/backend/common/service/users.service";
import {WorkedHoursApi} from "@core/services/backend/common/api/workedHours.api";
import {WorkedHoursData} from './common/interface/workedHours';
import {WorkedHoursService} from './common/service/workedHours.service';
import {SubAreasApi} from "@core/services/backend/common/api/subAreas.api";
import {SubAreasData} from './common/interface/subAreas';
import {SubAreasService} from './common/service/subAreas.service';
import {LinksApi} from "@core/services/backend/common/api/links.api";
import {LinksData} from './common/interface/links';
import {LinksService} from './common/service/links.service';
import {GroupsApi} from "@core/services/backend/common/api/groups.api";
import {GroupsData} from "@core/services/backend/common/interface/groups";
import {GroupsService} from "@core/services/backend/common/service/groups.service";
import {RolesApi} from "@core/services/backend/common/api/roles.api";
import {RoleData} from "@core/services/backend/common/interface/roles";
import {RolesService} from "@core/services/backend/common/service/roles.service";
import {NotificationsApi} from "@core/services/backend/common/api/notifications.api";
import {NotificationsData} from "@core/services/backend/common/interface/notifications";
import {NotificationsService} from "@core/services/backend/common/service/notifications.service";
import {ResponsibleApi} from "@core/services/backend/common/api/responsible.api";
import {ResponsibleData} from "@core/services/backend/common/interface/responsible";
import {ResponsibleService} from "@core/services/backend/common/service/responsible.service";
import {AutoHoursApi} from "@core/services/backend/common/api/autoHours.api";
import {AutoHoursData} from "@core/services/backend/common/interface/autoHours";
import {AutoHoursService} from "@core/services/backend/common/service/autoHours.service";
import {ClientsApi} from "@core/services/backend/common/api/clients.api";
import {ClientsData} from "@core/services/backend/common/interface/clients";
import {ClientsService} from "@core/services/backend/common/service/clients.service";
import {ProjectTypesApi} from "@core/services/backend/common/api/project-types.api";
import {ProjectTypesData} from "@core/services/backend/common/interface/project-types";
import {ProjectTypesService} from "@core/services/backend/common/service/project-types.service";
import {OriginsApi} from "@core/services/backend/common/api/origins.api";
import {OriginsData} from "@core/services/backend/common/interface/origins";
import {OriginsService} from "@core/services/backend/common/service/origins.service";
import {CurrenciesApi} from "@core/services/backend/common/api/currencies.api";
import {CurrenciesData} from "@core/services/backend/common/interface/currencies";
import {CurrenciesService} from "@core/services/backend/common/service/currencies.service";
import {LevelsApi} from "@core/services/backend/common/api/levels.api";
import {LevelsData} from "@core/services/backend/common/interface/levels";
import {LevelsService} from "@core/services/backend/common/service/levels.service";


const API = [
    ProjectsApi,
    ProjectsV2Api,
    UsersApi,
    WorkedHoursApi,
    SubAreasApi,
    LinksApi,
    GroupsApi,
    RolesApi,
    NotificationsApi,
    ResponsibleApi,
    AutoHoursApi,
    ClientsApi,
    ProjectTypesApi,
    OriginsApi,
    CurrenciesApi,
    LevelsApi,
    HttpService];

const SERVICES_DATA = [
    {
        provide: ProjectsData,
        useClass: ProjectsService
    },
    {
        provide: UsersData,
        useClass: UsersService
    },
    {
        provide: WorkedHoursData,
        useClass: WorkedHoursService
    },
    {
        provide: SubAreasData,
        useClass: SubAreasService
    },
    {
        provide: LinksData,
        useClass: LinksService
    },
    {
        provide: GroupsData,
        useClass: GroupsService
    },
    {
        provide: RoleData,
        useClass: RolesService
    },
    {
        provide: NotificationsData,
        useClass: NotificationsService
    },
    {
        provide: AutoHoursData,
        useClass: AutoHoursService
    },
    {
        provide: ResponsibleData,
        useClass: ResponsibleService
    },
    {
        provide: ClientsData,
        useClass: ClientsService
    },
    {
        provide: ProjectTypesData,
        useClass: ProjectTypesService
    },
    {
        provide: OriginsData,
        useClass: OriginsService
    },
    {
        provide: CurrenciesData,
        useClass: CurrenciesService
    },
    {
        provide: LevelsData,
        useClass: LevelsService
    }
];

const SERVICES = [
    ProjectsService,
    ProjectsV2Service,
    UsersService,
    WorkedHoursService,
    SubAreasService,
    GroupsService,
    LinksService,
    RolesService,
    NotificationsService,
    ResponsibleService,
    AutoHoursService,
    ClientsService,
    ProjectTypesService,
    OriginsService,
    CurrenciesService,
    LevelsService
];

@NgModule({
    declarations: [],
    imports: [
        CommonModule
    ]
})

export class CommonBackendModule {
    static forRoot(): ModuleWithProviders<CommonBackendModule> {
        return {
            ngModule: CommonBackendModule,
            providers: [
                ...API,
                ...SERVICES_DATA,
                ...SERVICES
            ],
        };
    }
}
